import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { Status as LoadStatus } from '~components/Job/LoadStatus';
import { Load } from '~hooks/useLoad/models';

interface StatusColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function StatusColumn({ load, sx }: StatusColumnProps) {
  return (
    <Box sx={sx}>
      <LoadStatus status={load.state} />
    </Box>
  );
}
